export default "__VITE_ASSET__TL_9RtTV__"